export enum ContactType {
    Phone = 'phone',
    Email = 'email',
    WhatsApp = 'whatsapp',
    Viber = 'viber',
    Telegram = 'telegram',
}
